import { render, staticRenderFns } from "./CalendarComponent.vue?vue&type=template&id=53d25b4e&"
import script from "./CalendarComponent.vue?vue&type=script&lang=js&"
export * from "./CalendarComponent.vue?vue&type=script&lang=js&"
import style0 from "./CalendarComponent.vue?vue&type=style&index=0&id=53d25b4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports